.root {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 24px;
}

.spinner {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2.5px solid var(--color-border);
  border-top-color: var(--color-brand-primary);
  animation: spin 900ms linear infinite;
}

.copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.label {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
}

.hint {
  font-size: 13px;
  color: var(--color-text-secondary);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
  }
}
